import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/ReceiveWax.css";

export default function CompletedWax() {
  const [lots, setLots] = useState([]);

  // Modal states
  const [selectedLot, setSelectedLot] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [castingDate, setCastingDate] = useState("");

  useEffect(() => {
    fetchCompletedLots();
  }, []);

  // ==========================================
  // FETCH COMPLETED LOTS
  // ==========================================
  const fetchCompletedLots = async () => {
    const { data: lotsData } = await supabase
      .from("WAX_LOTS")
      .select("id, lot_no, worker_id, issue_date, status")
      .eq("status", "COMPLETED")
      .order("issue_date", { ascending: false });

    if (!lotsData) return;

    const lotIds = lotsData.map((l) => l.id);

    // Get items with received data
    const { data: items } = await supabase
      .from("WAX_ITEMS")
      .select(`
        id,
        lot_id,
        item_id,
        design_code,
        issued_net,
        received_net,
        received_pcs,
        ITEMS(item_name)
      `)
      .in("lot_id", lotIds);

    const merged = lotsData.map((lot) => ({
      ...lot,
      items: items.filter((i) => i.lot_id === lot.id),
    }));

    setLots(merged);
  };

  // ==========================================
  // OPEN DATE MODAL
  // ==========================================
  const openDateModal = (lot, item) => {
    setSelectedLot(lot);
    setSelectedItem(item);
    setCastingDate("");
  };

  // ==========================================
  // SAVE CASTING DONE
  // ==========================================
  const saveCastingDone = async () => {
    if (!castingDate) {
      alert("Please select a date.");
      return;
    }

    const gainLoss = Number(selectedItem.received_net || 0) - Number(selectedItem.issued_net || 0);

    const { error } = await supabase.from("casting_done").insert({
      lot_id: selectedLot.id,
      lot_no: selectedLot.lot_no,
      item_id: selectedItem.item_id,
      wax_item_id: selectedItem.id,
      gain_loss: gainLoss,
      casting_date: castingDate,
    });

    if (error) {
      console.error(error);
      alert("Error saving casting data");
      return;
    }

    alert("Moved to Casting!");
    setSelectedItem(null);
    setSelectedLot(null);
    setCastingDate("");
  };

  // ==========================================
  // UI
  // ==========================================
  return (
    <div className="receive-container">
      <h2 className="page-title">Completed Wax Lots</h2>

      {/* DATE MODAL */}
      {selectedItem && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Select Casting Date</h3>

            <input
              type="date"
              value={castingDate}
              onChange={(e) => setCastingDate(e.target.value)}
            />

            <div className="modal-actions">
              <button className="confirm-btn" onClick={saveCastingDone}>
                Save
              </button>
              <button
                className="cancel-btn"
                onClick={() => {
                  setSelectedItem(null);
                  setSelectedLot(null);
                  setCastingDate("");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {lots.length === 0 && <p>No completed lots.</p>}

      {lots.map((lot) => {
        // TOTAL GAIN LOSS
        const totalGainLoss = lot.items.reduce((sum, it) => {
          const issued = Number(it.issued_net || 0);
          const received = Number(it.received_net || 0);
          return sum + (received - issued);
        }, 0);

        return (
          <div className="lot-card" key={lot.id}>
            <div className="lot-header">
              <h3>{lot.lot_no}</h3>
              <p>Date: {lot.issue_date?.slice(0, 10)}</p>
              <p>
                <b>Total Gain/Loss: </b>
                <span style={{ color: totalGainLoss >= 0 ? "green" : "red" }}>
                  {totalGainLoss.toFixed(3)}
                </span>
              </p>
            </div>

            <table className="wax-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Design</th>
                  <th>Issued Net</th>
                  <th>Received Net</th>
                  <th>Gain/Loss</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {lot.items.map((it) => {
                  const issued = Number(it.issued_net || 0);
                  const received = Number(it.received_net || 0);
                  const gainLoss = received - issued;

                  return (
                    <tr key={it.id}>
                      <td>{it.ITEMS?.item_name}</td>
                      <td>{it.design_code}</td>
                      <td>{issued}</td>
                      <td>{received}</td>
                      <td
                        style={{
                          fontWeight: "bold",
                          color: gainLoss >= 0 ? "green" : "red",
                        }}
                      >
                        {gainLoss.toFixed(3)}
                      </td>

                      <td>
                        <button
                          className="wax-btn"
                          onClick={() => openDateModal(lot, it)}
                        >
                          Move to Casting
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}
